// Version : 0.0.2
// Author : DINESH
// MODFIED DATA : 07-08-2025

import StaffActionTypes from './staff.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	getStaffListResponse: null,
	getStaffListArr: [],
	updateIsPublishStatus: null,
	deleteStaffDetailsResponse: null,
	addStaffDetailsResponse: null,
	fetchStaffDetailsResponse: null,
	fetchStaffDetailsArr: [],
	updateStaffDetailsResponse: null,
	updateIsPrintStaff: null,
	getAllStaffResponse: null,
	getAllStaffArr: [],
};
// eslint-disable-next-line import/no-anonymous-default-export
export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/***************** ADD STAFF DETAILS START ***********************/
		case StaffActionTypes.ADD_STAFF_DETAILS_SUCCESS:
			return { ...state, addStaffDetailsResponse: action.payload };

		case StaffActionTypes.ADD_STAFF_DETAILS_FAILURE:
			return { ...state, addStaffDetailsResponse: action.payload };

		case StaffActionTypes.ADD_STAFF_DETAILS_RESPONSE_CHANGED:
			return { ...state, addStaffDetailsResponse: null };
		/***************** ADD STAFF DETAILS END ***********************/

		/***************** UPDATE STAFF DETAILS START ***********************/
		case StaffActionTypes.UPDATE_STAFF_DETAILS_SUCCESS:
			return { ...state, updateStaffDetailsResponse: action.payload };

		case StaffActionTypes.UPDATE_STAFF_DETAILS_FAILURE:
			return { ...state, updateStaffDetailsResponse: action.payload };

		case StaffActionTypes.UPDATE_STAFF_DETAILS_RESPONSE_CHANGED:
			return { ...state, updateStaffDetailsResponse: null };
		/***************** UPDATE STAFF DETAILS END ***********************/

		/***************** GET STAFF LIST START ***********************/
		case StaffActionTypes.GET_STAFF_LIST_SUCCESS:
			return {
				...state,
				getStaffListResponse: action.payload,
				getStaffListArr: docodeHexResponse(action.payload, 'GetStaffListKey'),
			};

		case StaffActionTypes.GET_STAFF_LIST_FAILURE:
			return { ...state, getStaffListResponse: action.payload };

		case StaffActionTypes.GET_STAFF_LIST_RESPONSE_CHANGED:
			return { ...state, getStaffListResponse: null };
		/***************** GET STAFF LIST END ***********************/

		/***************** FETCH STAFF DETAILS START ***********************/
		case StaffActionTypes.FETCH_STAFF_DETAILS_SUCCESS:
			return {
				...state,
				fetchStaffDetailsResponse: action.payload,
				fetchStaffDetailsArr: docodeHexResponse(action.payload, 'FetchStaffDetailsKey'),
			};

		case StaffActionTypes.FETCH_STAFF_DETAILS_FAILURE:
			return {
				...state,
				fetchStaffDetailsResponse: action.payload,
				fetchStaffDetailsArr: [],
			};

		case StaffActionTypes.FETCH_STAFF_DETAILS_RESPONSE_CHANGED:
			return { ...state, fetchStaffDetailsResponse: null };

		case StaffActionTypes.FETCH_STAFF_DETAILS_RESET_COMPONENT_START:
			return { ...state, fetchStaffDetailsResponse: null, fetchStaffDetailsArr: [] };
		/***************** FETCH STAFF DETAILS END ***********************/

		/***************** DELETE STAFF DETAILS START ***********************/
		case StaffActionTypes.DELETE_STAFF_DETAILS_SUCCESS:
			return { ...state, deleteStaffDetailsResponse: action.payload };

		case StaffActionTypes.DELETE_STAFF_DETAILS_FAILURE:
			return { ...state, deleteStaffDetailsResponse: action.payload };

		case StaffActionTypes.DELETE_STAFF_DETAILS_RESPONSE_CHANGED:
			return { ...state, deleteStaffDetailsResponse: null };
		/***************** DELETE STAFF DETAILS END ***********************/

		/***************** UPDATE ISPUBLISH DETAILS START ***********************/
		case StaffActionTypes.UPDATE_ISPUBLISH_STATUS_SUCCESS:
			return { ...state, updateIsPublishStatus: action.payload };

		case StaffActionTypes.UPDATE_ISPUBLISH_STATUS_FAILURE:
			return { ...state, updateIsPublishStatus: action.payload };

		case StaffActionTypes.UPDATE_ISPUBLISH_STATUS_RESPONSE_CHANGED:
			return { ...state, updateIsPublishStatus: null };
		/***************** UPDATE ISPUBLISH DETAILS END ***********************/

		/***************** UPDATE ISPRINT DETAILS START ***********************/
		case StaffActionTypes.UPDATE_ISPRINT_STAFF_SUCCESS:
			return { ...state, updateIsPrintStaff: action.payload };

		case StaffActionTypes.UPDATE_ISPRINT_STAFF_FAILURE:
			return { ...state, updateIsPrintStaff: action.payload };

		case StaffActionTypes.UPDATE_ISPRINT_STAFF_RESPONSE_CHANGED:
			return { ...state, updateIsPrintStaff: null };
		/***************** UPDATE ISPRINT DETAILS START ***********************/

		/***************** GET ALL STAFF START ***********************/
		case StaffActionTypes.GET_ALL_STAFF_SUCCESS:
			return {
				...state,
				getAllStaffResponse: action.payload,
				getAllStaffArr: docodeHexResponse(action.payload, 'GetAllStaffKey'),
			};

		case StaffActionTypes.GET_ALL_STAFF_FAILURE:
			return { ...state, getAllStaffResponse: action.payload };

		case StaffActionTypes.GET_ALL_STAFF_RESPONSE_CHANGED:
			return { ...state, getAllStaffResponse: null };

		/***************** GET ALL STAFF END ***********************/

		default:
			return state;
	}
};
